module.exports = __webpack_public_path__ + "static/media/onefm.9af8d841.png";